export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

const initialState = {
  sending: false,
  succeed: null,
  rejected: null,
  error: null,
};

const locationReducer = reducer => (state = initialState, action = {}) => {
  const { type } = action;
  switch (type) {
    case LOCATION_CHANGE: {
      return initialState;
    }
    default: {
      return reducer(state, action);
    }
  }
};

export default locationReducer;



// WEBPACK FOOTER //
// ./src/utils/redux/location-reducer.js